import { http, HttpResponse, delay } from 'msw';

import {
  SLACK_SUB_RESOURCE_APP_ID,
  slackChannelsAdded,
  slackChannelsRemoved,
} from '@/mocks/data/groupChangeSubResourceData';

// Simulates the (not-yet-implemented) Group Change sub-resource endpoints so the
// picker UI can be tested under `npm run dev:mock`. See the data file note.
export const groupChangeSubResourceHandlers = [
  http.get(
    `*/v1/organizations/:organizationId/group-change/:requestId/apps-with-sub-resources`,
    async () => {
      await delay(200);
      return HttpResponse.json(
        { app_ids: [SLACK_SUB_RESOURCE_APP_ID] },
        { status: 200 }
      );
    }
  ),
  http.get(
    `*/v1/organizations/:organizationId/group-change/:requestId/apps/:appId/sub-resources`,
    async ({ request }) => {
      const ctx = new URL(request.url).searchParams.get('ctx');
      const isRemoved = ctx === 'removed';
      const results = isRemoved ? slackChannelsRemoved : slackChannelsAdded;
      await delay(200);
      return HttpResponse.json(
        {
          results,
          total: results.length,
          resource_type: 'Channel',
          group_name: isRemoved ? 'Engineering' : 'Design',
        },
        { status: 200 }
      );
    }
  ),
];
